import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="row">
        <div className="col-md-3">
          <div className="footer-logo-content">
            <Link to="/">
              <img
                src="images/vitri-blue-logo.png"
                alt="VITRI ENTERPRISES Logo"
                className="footer-logo"
              />
            </Link>
          </div>
        </div>

        <div className="col-md-3">
          <div className="footer-col">
            <h4>About</h4>
            <p>
              Vitri Enterprises is a trusted solution provider and turnkey
              system integrator specializing in Electronic Security Systems.
              With over 14+ years of experience in the Indian market, we deliver
              reliable, efficient, and innovative security solutions tailored to
              client needs.
            </p>
          </div>
        </div>

        {/* Contact Section */}
        <div className="col-md-3">
          <div className="footer-col">
            <h4>Contact Us</h4>
            <ul>
              <li>
                <span>
                  <i className="fa fa-map-marker"></i>
                </span>
                &nbsp;
                <a
                  href="https://www.google.com/maps?q=61,+Govardhan+business+hub,+Rd+Number+5,+Kathwada+GIDC,+Odhav+Industrial+Estate,+Odhav,+Ahmedabad,+Gujarat+382430"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  61, Govardhan business hub, Rd Number 5, Kathwada GIDC, Odhav
                  Industrial Estate, Odhav, Ahmedabad, Gujarat 382430
                </a>
              </li>
              <li>
                <span>
                  <i className="fa fa-phone"></i>
                </span>
                &nbsp;
                <a href="tel:+919624930796">+91-9624930796</a>
              </li>
              <li>
                <span>
                  <i className="fa fa-envelope"></i>
                </span>
                &nbsp;
                <a href="mailto:vitrienterprises@gmail.com">
                  vitrienterprises@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Social Section */}
        <div className="col-md-3">
          <div className="footer-col">
            <h4>Follow Us</h4>
            <div className="social-links">
              <a href="/" className="social-icon">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="/" className="social-icon">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="/" className="social-icon">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="/" className="social-icon">
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <section className="footer_section">
        <div
          className="container"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <p>
            <span id="displayYear"></span> Developed by{" "}
            <Link to="https://siddhisolutions.in/">Siddhi Solutions</Link>
          </p>
          <p>
            &copy; <span id="displayYear"></span> All Rights Reserved by{" "}
            <Link to="/">Vitri Enterprises</Link>
          </p>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
